const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#fefefe",
    d: "M 233.5,-0.5 C 248.167,-0.5 262.833,-0.5 277.5,-0.5C 377.769,12.0418 449.269,64.0418 492,155.5C 502.296,180.684 508.796,206.684 511.5,233.5C 511.5,248.167 511.5,262.833 511.5,277.5C 498.958,377.769 446.958,449.269 355.5,492C 330.316,502.296 304.316,508.796 277.5,511.5C 262.833,511.5 248.167,511.5 233.5,511.5C 133.231,498.958 61.7312,446.958 19,355.5C 8.70393,330.316 2.20393,304.316 -0.5,277.5C -0.5,262.833 -0.5,248.167 -0.5,233.5C 12.0418,133.231 64.0418,61.7312 155.5,19C 180.684,8.70393 206.684,2.20393 233.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0eb6d4",
    d: "M 239.5,134.5 C 271.995,131.155 301.328,138.989 327.5,158C 340.5,170.333 353.5,182.667 366.5,195C 391.829,211.099 416.496,210.099 440.5,192C 446.036,186.285 451.369,181.118 456.5,176.5C 443.295,227.862 410.129,254.196 357,255.5C 326.578,255.858 300.078,246.024 277.5,226C 266.104,213.935 254.104,202.602 241.5,192C 216.444,177.85 192.777,179.85 170.5,198C 165.3,202.865 160.467,208.032 156,213.5C 165.558,167.773 193.392,141.44 239.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0eb6d4",
    d: "M 145.5,254.5 C 175.947,252.772 203.281,260.938 227.5,279C 239.137,289.637 250.471,300.637 261.5,312C 285.135,331.023 309.802,332.357 335.5,316C 342.667,310.167 349.167,303.667 355,296.5C 342.569,349.564 308.903,375.897 254,375.5C 224.194,375.837 198.36,366.004 176.5,346C 166.137,335.303 155.471,324.97 144.5,315C 119.096,298.85 94.4294,299.85 70.5,318C 64.967,323.198 59.8004,328.698 55,334.5C 65.6802,285.749 95.8468,259.083 145.5,254.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.ca41ccd7447108b50e39809df77b9698.svg";
export { ForwardRef as ReactComponent };